import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-site-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './site-footer.component.html',
  styleUrl: './site-footer.component.css'
})
export class SiteFooterComponent {
  readonly year = new Date().getFullYear();

  readonly footerLinks = [
    { label: 'Services', path: '/services' },
    { label: 'Q & A', path: '/q-and-a' },
    { label: 'Testimonials', path: '/testimonials' },
    { label: 'Contact Us', path: '/contact-us' },
    { label: 'About Us', path: '/about-us' },
    { label: 'Legal', path: '/legal' }
  ];
}
